module.exports = __webpack_public_path__ + "img/itx-file-type-warning.608de846.svg";